import { AnimationProps, Variants } from "motion/react";

// Route Animations
const routeVariants: Variants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
};

export const defaultRouteTransition: AnimationProps = {
  variants: routeVariants,
  initial: "initial",
  animate: "in",
  exit: "out",
  transition: {
    opacity: { ease: ["easeInOut"], duration: 0.2 },
  },
};

// Section Animations
const sectionVariants: Variants = {
  initial: {
    x: "50vw",
    opacity: 0,
  },
  in: {
    x: "0vw",
    opacity: 1,
  },
  out: {
    x: "-50vw",
    opacity: 0,
  },
};

export const defaultSectionTransition: AnimationProps = {
  variants: sectionVariants,
  initial: "initial",
  animate: "in",
  exit: "out",
  transition: {
    opacity: { ease: ["easeInOut"], duration: 0.4 },
    x: { type: "spring", mass: 0.4, duration: 1.5 },
  },
};

// No Transition
const noTransitionVariants: Variants = {
  initial: { opacity: 1, scale: 1 },
  in: { opacity: 1, scale: 1 },
  out: { opacity: 1, scale: 1 },
};

export const noTransition: AnimationProps = {
  variants: noTransitionVariants,
  initial: "initial",
  animate: "in",
  exit: "out",
  transition: {opacity: { duration: 0 },},
};

// Game Animations
const gameBgVariants: Variants = {
  initial: {
    opacity: 0,
    scale: 0.9,
  },
  in: {
    opacity: 1,
    scale: 1,
  },
  out: {
    opacity: 0,
    scale: 1.4,
  },
};

export const gameBgTransition: AnimationProps = {
  variants: gameBgVariants,
  initial: "initial",
  animate: "in",
  exit: "out",
  transition: {
    opacity: { ease: ["easeInOut"], duration: 0.4 },
  },
};

const gameModalVariants: Variants = {
  initial: {
    y: "10vh",
    opacity: 0,
  },
  in: {
    y: "0vh",
    opacity: 1,
    transition: {
      opacity: { ease: ["easeInOut"], duration: 0.4, delay: 2 },
      y: { type: "spring", mass: 0.4, duration: 1.4, delay: 2 },
    },
  },
  out: {
    y: "10vh",
    opacity: 0,
    transition: {
      opacity: { ease: ["easeInOut"], duration: 0.4, delay: 0 },
      y: { type: "spring", mass: 0.4, duration: 1.4, delay: 0 },
    },
  },
};

export const gameModalTransition: AnimationProps = {
  variants: gameModalVariants,
  initial: "initial",
  animate: "in",
  exit: "out",
};

const dashboardVariants: Variants = {
  initial: {
    y: "-100%",
    opacity: 0,
  },
  in: {
    y: "0",
    opacity: 1,
  },
  out: {
    x: "-100vw",
    opacity: 0,
  },
};

export const dashboardTransition: AnimationProps = {
  variants: dashboardVariants,
  initial: "initial",
  animate: "in",
  exit: "out",
  transition: {
    opacity: { ease: ["easeInOut"], duration: 0.4 },
    y: { type: "spring", mass: 0.4, duration: 1.4 },
  },
};
